import {LimsMeasurementType} from '../types/LimsMeasurementType'
import {MeasurementTypesMapping} from '../types/MeasurementTypesMapping'

export function getUnmappedLimsMeasurementTypes(
  limsMeasurementTypes?: LimsMeasurementType[],
  measurementTypesMappings?: MeasurementTypesMapping[]
) {
  if (limsMeasurementTypes === undefined || measurementTypesMappings === undefined) return []

  const mappedLimsMeasurementTypesIds = measurementTypesMappings.map(
    (mapping) => mapping.limsMeasurementTypeId
  )
  return limsMeasurementTypes.filter(
    (limsType) => !mappedLimsMeasurementTypesIds.includes(limsType.id)
  )
}
